module.exports = require("yaml-js");


//////////////////
// WEBPACK FOOTER
// external "yaml-js"
// module id = 553
// module chunks = 0